import Header from "@components/Header/Header"
import TopUpOptionList from "@components/TopUpOptionList/TopUpOptionList"
import { useNavigate } from "react-router"
import { Container, ContentContainer } from "./TopUpBankSelect.styles"
import { useTranslation } from "react-i18next"
import useSupportedVirtualAccount from "@hooks/useSupportedVirtualAccount"
import LoadingModal from "@components/LoadingModal/LoadingModal"
import { useEffect } from "react"
import { setHeaderColor } from "@lib/telegram"
import { WHITE } from "@styles/colors"

const TopUpBankSelect = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { data: supportedVirtualAccount, isLoading } = useSupportedVirtualAccount()

    useEffect(() => {
        setHeaderColor(WHITE)
    }, [])

    return (
        <Container>
            <Header title={t('topUpBank.select.header')} showBackButton onBackClick={() => navigate('/top-up-method')} />
            <ContentContainer>
                {supportedVirtualAccount && !isLoading ? <TopUpOptionList 
                    title={t('topUpBank.select.indonesianBanks')}
                    options={supportedVirtualAccount.map((bank) => {
                        if (bank.is_default_fallback) {
                            // looks easier to read than using shorthand
                            return {
                                id: bank.id,
                                name: bank.display_name,
                                iconUrl: bank.icon_url,
                                iconPlaceholder: 'bank',
                                max_amount: bank.max_amount,
                                min_amount: bank.min_amount
                            }
                        }

                        return {
                            id: bank.id,
                            name: bank.display_name,
                            iconUrl: bank.icon_url,
                            max_amount: bank.max_amount,
                            min_amount: bank.min_amount
                        }
                    })}
                    onClick={(option) => navigate('/top-up-bank-input-amount', { state: { bank: option } })}
                /> : <LoadingModal visible={isLoading} />}
            </ContentContainer>
        </Container>
    )
}

export default TopUpBankSelect